import React from "react";
import PageHeader from "../../components/PageHeader";
import VehicleViewComponent from "../../components/Vehicle/VehicleView";

class VehicleView extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Vehicle Detail"
                            Breadcrumb={[
                                { name: "Vehicles", navigate: "/vehicle" },
                                { name: "Vehicle Detail", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <VehicleViewComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default VehicleView;
